<!-- somewhere in your root component template -->
<app-toast aria-live="polite" aria-atomic="true"></app-toast>
<kt-splash-screen></kt-splash-screen>
<router-outlet></router-outlet>
